import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'
import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'

// New Pages Mysemeq
import Home from 'src/components/Dashboard/Views/Pages/Home.vue'
import Online from 'src/components/Dashboard/Views/Pages/Online.vue'
import Online2 from 'src/components/Dashboard/Views/Pages/Online2.vue'
import Release from 'src/components/Dashboard/Views/Pages/Release.vue'
import Language from 'src/components/Dashboard/Views/Pages/Language.vue'
import Tour from 'src/components/Dashboard/Views/Pages/Tour.vue'
import Testes from 'src/components/Dashboard/Views/Pages/Testes.vue'

// Pages CRUD
import ComponentType from 'src/components/Dashboard/Views/Crud/ComponentType.vue'

// store vuex
import Vue from 'vue'
import Router from 'vue-router'
import store from 'src/store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let pagesMenu = {
  path: '/',
  component: DashboardLayout,
  redirect: '/home',
  children: [
    // {
    //   path: 'user',
    //   name: 'User Page',
    //   component: User
    // },
    // {
    //   path: 'timeline',
    //   name: 'Timeline Page',
    //   component: TimeLine
    // },
    {
      path: 'home',
      name: 'menu.saude.das.plantas',
      component: Home,
      beforeEnter: ifAuthenticated
    },
    {
      path: 'online',
      name: 'Online',
      component: Online,
      beforeEnter: ifAuthenticated
    },
    {
      path: 'online2',
      name: 'Online2',
      component: Online2,
      beforeEnter: ifAuthenticated
    },
    {
      path: 'release',
      name: 'Release Notes',
      component: Release,
      beforeEnter: ifAuthenticated
    },
    {
      path: 'language',
      name: 'Language',
      component: Language,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: 'tour',
    //   name: 'Tour',
    //   component: Tour,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: 'testes',
    //   name: 'Testes',
    //   component: Testes,
    //   beforeEnter: ifAuthenticated
    // },
  ]
}

let CadastroPage = {
  path: '/crud',
  component: DashboardLayout,
  redirect: '/crud/ComponentType',
  children: [
    {
      path: 'ComponentType',
      name: 'menu.crud.component.type',
      component: ComponentType
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
  beforeEnter: ifNotAuthenticated
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/home'
  },
  // componentsMenu,
  // formsMenu,
  // tablesMenu,
  pagesMenu,
  loginPage,
  // CadastroPage,
  registerPage,
  // lockPage,
  // {
  //   path: '/admin',
  //   component: DashboardLayout,
  //   redirect: '/admin/overview',
  //   children: [
  //     {
  //       path: 'overview',
  //       name: 'Overview',
  //       component: Overview,
  //       beforeEnter: ifAuthenticated
  //     },
  //     {
  //       path: 'stats',
  //       name: 'Stats',
  //       component: Stats
  //     }
  //   ]
  // },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js